"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchDeletionConfirmationModal = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Col_1 = require("@amzn/atoz-web/Col");
var Row_1 = require("@amzn/atoz-web/Row");
var Text_1 = require("@amzn/atoz-web/Text");
var Modal_1 = require("@amzn/atoz-web/Modal");
var Text_2 = require("@amzn/atoz-web/Text");
var Button_1 = require("@amzn/atoz-web/Button");
var PunchDeletionConfirmationModal = function (_a) {
    var closeModal = _a.closeModal, acceptPunchDeletion = _a.acceptPunchDeletion, punchDateTime = _a.punchDateTime;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Modal_1.ModalContent, { onCloseButtonClick: closeModal, dataTestId: "punch-deletion-modal", titleText: "" },
        react_1.default.createElement(Col_1.Col, { justifyContent: "space-between", gridGap: "S500", padding: "S300" },
            react_1.default.createElement(Text_2.H2, { fontSize: "T500" }, t('time_and_attendance_PunchDeletionConfirmationModal_Title')),
            react_1.default.createElement(Text_1.Text, null, t('time_and_attendance_PunchDeletionConfirmationModal_Content')),
            react_1.default.createElement(Row_1.Row, { justifyContent: "space-between" },
                react_1.default.createElement(Button_1.Button, { key: "PunchDeletionConfirmationModalCancelButton", variant: Button_1.ButtonVariant.Tertiary, onClick: closeModal, dataTestId: "punch-deletion-modal-cancel" }, t('time_and_attendance_PunchDeletionConfirmationModal_Cancel')),
                react_1.default.createElement(Button_1.Button, { key: "PunchDeletionConfirmationModalSubmitButton", variant: Button_1.ButtonVariant.Primary, onClick: function () { return acceptPunchDeletion(punchDateTime); }, dataTestId: "punch-deletion-modal-continue" }, t('time_and_attendance_PunchDeletionConfirmationModal_Confirm'))))));
};
exports.PunchDeletionConfirmationModal = PunchDeletionConfirmationModal;
